<template>
    <form
      class="ecommerce-form action-buttons-fixed"
      @submit.prevent="submitForm"
    >
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">
                    {{ translations.detailsInfo }}
                  </h2>
                  <p class="card-big-info-desc">
                    {{ translations.details }}
                  </p>
                </div>
                <div class="col-lg-3-5 col-xl-4-5">
                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.brand.title.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Title</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Title"
                        v-model="brand.title"
                      />

                      <form-error
                        :model="$v.brand.title"
                        :dirty="$v.$dirty"
                        label="naziv"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Opis</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <textarea
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Opis"
                        v-model="brand.description"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3" v-if="brand.imageUrl">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Slika</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <div class="popup-gallery row">
                        <div
                          class="img-fluid"
                        >
                          <img
                            class="img-thumbnail"
                            :src="`${baseUrl}${brand.imageUrl}`"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Slika</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="file"
                        class="form-control form-control-modern"
                        ref="photo"
                        accept="image/*"
                      />

                      <span class="form-text">
                        Učitajte sliku rezolucije 200px x 60px
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-tag"></i>
                  <h2 class="card-big-info-title">{{ translations.metaSeoDetails }}</h2>
                  <p class="card-big-info-desc">
                    {{ translations.metaSeo }}
                  </p>
                </div>

                <div class="col-lg-3-5 col-xl-4-5">
                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Naslov</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naziv"
                        v-model="brand.metaSeo.title"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Opis</label>
                    <div class="col-lg-7 col-xl-6">
                      <textarea
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Opis"
                        v-model="brand.metaSeo.description"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Keyword</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Keyword"
                        v-model="brand.metaSeo.keyword"
                      />
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="action-buttons d-flex justify-content-between">
        <div>
          <button
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#delete-modal"
            class="delete-button btn btn-danger btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          >
            <i class="bx bx-trash text-4 me-2"></i> {{ translations.delete }}
          </button>
        </div>
        <div class="d-flex gap-3">
          <router-link
            exact
            :to="{ name: 'Brands' }"
            class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
          >
            {{ translations.cancel }}
          </router-link>
          <button
            type="submit"
            class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>
      <modal id="delete-modal">
        <h5 slot="header">
          <strong>{{ translations.deleteBrand }}</strong>
        </h5>
        <div slot="body">
          <span v-html="modalText"> </span>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                type="button"
                class="btn btn-primary px-4 mx-2"
                @click.prevent.stop="deleteBrand"
                data-bs-dismiss="modal"
              >
                {{ translations.yes }}
              </button>
              <button
                type="button"
                class="btn btn-default px-4"
                data-bs-dismiss="modal"
              >
                {{ translations.no }}
              </button>
            </div>
          </div>
        </div>
      </modal>
    </form>
</template>

<script>
import { translations } from '@/mixins';
import api from '@/services/api';
import config from '@/config';
import validations from './validation-schema/add';
import FormError from '../shared/form-errors/FormError.vue';
import Modal from '../shared/modal/Modal.vue';

export default {
  name: 'EditBrand',
  components: {
    FormError,
    Modal
  },
  mixins: [translations],
  validations: {
    brand: {
      ...validations
    }
  },
  computed: {
    modalText() {
      return this.translations.areYouSureBrand.replace(
        '{brand}',
        `<strong>${this.brand.title}</strong>`
      );
    },
    brand() {
      const selectedBrand = this.$store.getters.getBrand;
      return {
        ...selectedBrand,
        metaSeo: selectedBrand.metaSeo || {
          title: null,
          description: null,
          keyword: null
        }
      }
    },
    isFormValid() {
      return !this.$v.$invalid;
    },
    baseUrl() {
      return config.baseUrl;
    }
  },
  mounted() {
    this.$store.dispatch('getBrand', this.$route.params.id);
  },
  methods: {
    submitForm() {
      this.$v.$touch();
      if (!this.isFormValid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }

      const { brand } = this;

      const formData = new FormData();

      formData.append('title', brand.title);
      formData.append('description', brand.description || '');
      formData.append('id', brand.id);

      if (this.$refs.photo.files[0]) {
        formData.append('Image', this.$refs.photo.files[0]);
      }

      if (this.brand.metaSeo.title) {
        formData.append('metaSeo.title', this.brand.metaSeo.title);
      }

      if (this.brand.metaSeo.description) {
        formData.append('metaSeo.description', this.brand.metaSeo.description);
      }

      if (this.brand.metaSeo.keyword) {
        formData.append('metaSeo.keyword', this.brand.metaSeo.keyword);
      }

      api
        .updateBrand(formData)
        .then(response => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'Brands' });
        })
        .catch(err => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        });
    },
    deleteBrand() {
      api
        .deleteBrands([this.brand.id])
        .then(response => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'Brands' });
        })
        .catch(err => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
          this.$router.push({ name: 'Brands' });
        });
    }
  }
};
</script>
